// extracted by mini-css-extract-plugin
export default {"container":"dqAdqX","isPinned":"o467pO","isReactionsEnabled":"rvCVBU","postTitle":"ZCmPZl","contentExcerpt":"Avmupx","coverMedia":"UNzKyD"};